<script>
import { inject, onMounted, onUnmounted, reactive, useSlots } from 'vue';

export default {
    props: {
        uid: { type: String, default: () => crypto.randomUUID() },
        // type: { type: 'break'|'speaker'|'text' },
        type: { type: String },
        startTime: { type: [String] },
        endTime: { type: [String] },
        expanded: { type: [Boolean] },
    },
    setup(props) {
        const { register, unregister } = inject('time-table', { register: ()=>{}, unregister: ()=>{} })

        const timeSlot = reactive({
            uid: props.uid,
            type: props.type,
            expanded: props.expanded,
            startTime: props.startTime,
            endTime: props.endTime,
            summary: null,
            details: null,
        })

        const slots = useSlots()

        onMounted(() => {
            if (slots.summary) {
                timeSlot.summary = slots.summary()
            }
            if (slots.details) {
                timeSlot.details = slots.details()
            }

            register(timeSlot)
        })
        onUnmounted(() => { unregister(timeSlot) })

        return () => null
    }
}
</script>
